import React, { useState, useEffect } from 'react'

import Left_menu from './Left_menu'
import Header from './Header'
import Create_order_nav from './Create_order_nav'
import axios from 'axios'
import queryString from 'query-string';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
// import './customer_style.css';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';


import Swal from 'sweetalert2'
import { useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';
import config from "../../config"
import { useNetworkState } from 'react-use';
import Order_left_panel from './Order_left_panel'
import Footer from '../Footer'
const Create_order_3 = () => {
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
    let navigate = useNavigate();
    const isOnline = useNetworkState();
    console.log("isONline  === " ,isOnline )
   const location = useLocation()
//  console.log("location==>122", location)
  let  parsed = queryString.parse(location.search);
  // console.log("parsed",parsed);
  const [totalValue, setTotalValue] = useState(0);
  const [orderNumber, setOrderNumber] = useState('');
  
  const[parceltype,setparceltypeState] = useState({parcel:true})
  const[documenttype,setdocumenttypeState] = useState({document:false})
  const[state,setState] = useState({  parcel_type:"Parcel" , order_date : "" , order_number:"" })
  // console.log("state==== " , state)
  const [rowstate, setRowState] = React.useState([{ weight: "", height: "", width: "", length: "", buttonType: "add",error:{} }])
  const [shipstate, setShipstate] = React.useState([{shipment_content:"",total_value:"",quantity:"" ,buttonType: "add", error:{}}])
  // console.log("shipstate ==== " , shipstate)
  const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})
  const[paymentmode,setpaymentmode]= useState({mode:2})
  // console.log("paymentmode",paymentmode)
  const [codvalue,setcodvalue] = useState({cod_amount:0 , err:{}})
  // console.log("codvalue",codvalue)
  const [insurancestate, setinsurance] = useState({ insurance: 0 })
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
      const homeSection = document.querySelector('.home-section');
      if (homeSection) {
          homeSection.classList.toggle('sidebar-closed');
      }
  };
  useEffect(() => {
    generateOrderNumber();
    dimension_detail();

    if(parsed.order_id!="" && parsed.order_date!="" && parsed.shipment_type!=""  && parsed.payment_mode!="" ){
      setState({...state , parcel_type:parsed.shipment_type , order_number:parsed.order_id , order_date:parsed.order_date})
      if(parsed.shipment_type=="Document"){
        setdocumenttypeState({document:true})
        setparceltypeState({parcel:false})

      }
      else{
        setparceltypeState({parcel:true})
        setdocumenttypeState({document:false})

      }
      if(parsed.payment_mode=="prepaid"){
        setpaymentmode({mode:1})
      }
      else{
        setpaymentmode({mode:2})
        setcodvalue({...codvalue,cod_amount:parsed.cod_amount , err:{}})
      }

      if(parsed.items!=""){
        // console.log("items===")
        if( parsed.items.length>0){
        let parsedItems = JSON.parse(parsed.items)
        // console.log("parsedItems === " , parsedItems)
        const newShipstate = parsedItems.map((item, index) => ({
          shipment_content: item.item_name,
          total_value: item.item_value,
          quantity: item.item_quantity,
          buttonType: index === 0 ? "add" : "minus",
          error: {}
        }));
        setShipstate(newShipstate);
      }
      }
    }
  }, []);

  const dimension_detail = () =>{
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};
  
    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
      // console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
       //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }

  const generateOrderNumber = () => {
    // Generate the order number logic
    const randomNumber = Math.floor(Math.random() * 1000000);
    const formattedOrderNumber =  + randomNumber;

    setOrderNumber(formattedOrderNumber);
    const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
     let order_date = `${year}-${month}-${day}`;
    setState({...state , order_number:formattedOrderNumber ,order_date:order_date })
  }
 
  const handleChange=(e)=>{
    // console.log("namess",e.target.name)
    // console.log("value",e.target.value)
   
    let names = e.target.name
    let value= e.target.value
   
    if(e.target.type=="text"){
    setState({...state,[e.target.name]:value})
    }
    else if(e.target.type=="radio"){
        if(e.target.checked==true){
          
             if(e.target.name=="document"){
              setparceltypeState({...parceltype,parcel:false})
              setdocumenttypeState({...documenttype,document:true})
              setState({...state,parcel_type:"Document"})
            }
            else{
              setparceltypeState({...parceltype,parcel:true})
              setdocumenttypeState({...documenttype,document:false})
              setState({...state,parcel_type:"Parcel"})
            }
        }
    }
    else if(e.target.type=="number"){
      setState({...state,[e.target.name]:value})
    }
    else if(e.target.type=="date"){
        setState({...state,[e.target.name]:value})
       
    }
}
function addRows(type, index) {
    // console.log("type    ", type, " . ", index)
    let items = [...rowstate];
    let ship_items = [...shipstate];
    // console.log("items    ", items)
    if (type == 1) {
      let newItem = { weight: "", height: "", width: "", length: "", buttonType: "remove",error:{} };
      // console.log("newItem  =========>   ", newItem)
      let newShipItem = {shipment_content:"",total_value:"",quantity:"" ,buttonType: "remove", error:{}};

      items.push(newItem);
      ship_items.push(newShipItem);
    
      // console.log("items  =========>   ", items)

      setRowState(items)
      setShipstate(ship_items)
    } else if (type == 2) {
      items.splice(index, 1);
      ship_items.splice(index,1)
      setRowState(items)
      setShipstate(ship_items)
    }
  }
  
  const handleChange3 = (e, index) => {
    //  console.log("eee",e.target.value.length)
    let items = [...shipstate];
    let names = e.target.name;
    let value = e.target.value;
    if(e.target.type=="number"){
    if(value > 0 ) {
      items[index].error[names] = false;
    }else{
      items[index].error[names] = true;
    }
}
else{
    if(value.length > 0 ) {
        items[index].error[names] = false;
      }else{
        items[index].error[names] = true;
      }
}
   // console.log(items[index][names])
    items[index][names] = value;
    setShipstate(items)
    //setState({ ...state, [names]: value })
  }
  const payment_mode =(e)=>{
    if(e.target.name=="prepaid"){
      setpaymentmode({mode:1})
    }
    else{
      setpaymentmode({mode:2})
    }
  }
  
  const codvalueChange=(e)=>{
      
    setcodvalue({...codvalue,cod_amount:e.target.value , err:{}})
  }
  const next_step = () => {
    // console.log("order_id")
   
    // let items = [...rowstate];
    //   let flag = true;
    //   items.map((val)=>{
    //    // console.log("val=> ",val);
    //    val.error = {};
    //     if(val.weight == "" || val.weight <= 0) {
    //       val.error["weight"] = true;     
    //       flag = false;   
    //     }
    //     if(val.height == "" || val.height <= 0) {
    //       val.error["height"] = true;     
    //       flag = false;     
    //     }
    //     if(val.width == "" || val.width <= 0) {
    //       val.error["width"] = true;    
    //       flag = false;      
    //     }
    //     if(val.length == "" || val.length <= 0) {
    //       val.error["length"] = true;    
    //       flag = false;      
    //     }
    //     console.log("val=> ",val);
    //   })
    //   setRowState(items)

      let ship_items = [...shipstate];
      let fl = true;
      ship_items.map((val)=>{
       // console.log("val=> ",val);
       val.error = {};
        if(val.total_value == "") {
          val.error["total_value"] = true;     
          fl = false;   
        }
        if(val.shipment_content == "") {
          val.error["shipment_content"] = true;     
          fl = false;     
        }
        if(val.quantity == "" || val.quantity<0) {
          val.error["quantity"] = true;    
          fl = false;      
        }
      
        // console.log("val=> ",val);
      })
      setShipstate(ship_items)
  
    if(state.parcel_type!=""){
    if ( fl ) {
       if(paymentmode.mode==1 || paymentmode.mode==2 && codvalue.cod_amount!="" ){
     
                                navigate({pathname:`/customer/create_order_4`,
                                search: `sender_name=${parsed.sender_name}&sender_address=${parsed.sender_address}&sender_country=${parsed.sender_country}&sender_country_code=${parsed.sender_country_code}&sender_postal_code=${parsed.sender_postal_code}&sender_state_name=${parsed.sender_state_name}&sender_city=${parsed.sender_city}&sender_address_id=${parsed.sender_address_id}&sender_city_id=${parsed.sender_city_id}&sender_mobile=${parsed.sender_mobile}&sender_email=${parsed.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&return_name=${parsed.return_name}&return_email=${parsed.return_email}&return_mobile=${parsed.return_mobile}&return_address=${parsed.return_address}&return_country=${parsed.return_country}&return_country_code=${parsed.return_country_code}&return_postal_code=${parsed.return_postal_code}&return_city=${parsed.return_city}&return_state_name=${parsed.return_state_name}&mode=${parsed.mode}${shipstate.map((sub)=>(`&items=${sub.total_value},${sub.shipment_content.replace(/,/g, '')},${sub.quantity}`))}&shipment_type=${state.parcel_type}&insurance=${insurancestate.insurance}&order_id=${state.order_number}&order_date=${state.order_date}&cod_amount=${codvalue.cod_amount}&payment_mode=${paymentmode.mode==1?"prepaid":"cod"}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_city_id=${parsed.receiver_city_id}&receiver_state_id=${parsed.receiver_state_id}&carrier_type=${parsed.carrier_type}&order_type=${parsed.order_type}`
                              })   
                          
       }
       else{
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })
        
        Toast.fire({
          background:"rgb(231, 91, 75)",
          type: 'unsuccess',
          title: "Please enter cod value",
          color:"white"
        });
       }
   
      
 
    }
    else{
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
      
      Toast.fire({
        background:"rgb(231, 91, 75)",
        type: 'unsuccess',
        title: "Please fill all the Details",
        color:"white"
      });
      // console.log("----error:   ");      
    }
}else{
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
      
      Toast.fire({
        background:"rgb(231, 91, 75)",
        type: 'unsuccess',
        title: "Please Select Shipment Type",
        color:"white"
      });
      // console.log("----error:   "); 
}

  
}
useEffect(() => {
  calculateTotalValue();
}, [shipstate]);

// const calculateTotalValue = () => {
//   const total = shipstate.reduce((acc, item) => acc + parseFloat(item.total_value || 0), 0);
//   setTotalValue(total.toFixed(2)); // You can format the total as needed.
// };
const calculateTotalValue = () => {
  const total = shipstate.reduce((acc, item) => {
    // Ensure total_value and quantity are parsed as numbers
    const totalValue = parseFloat(item.total_value) || 0;
    const quantity = parseFloat(item.quantity) || 0;
    // Calculate item total by multiplying total_value by quantity
    return acc + (totalValue * quantity);
  }, 0);

  // Set the total value, formatted to 2 decimal places
  setTotalValue(total.toFixed(2));
  setcodvalue({cod_amount:total.toFixed(2)})
};

// useEffect(() => {
//   // Function to get the current date in the format YYYY-MM-DD
//   const getCurrentDate = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   };

//   // Set the orderDate state with the current date when the component mounts
//   const currentDate = getCurrentDate();
//   setState({...state,currentDate});
// }, []);
  return (
    <div>
      <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="home-section">
         
          <Header/>
        
        {/* <?php include 'create_order_nav.php';?>  */}
<Create_order_nav />
        <section class="mb-3">
          <div class="">
            <div class="row">
              <div class="col-12 col-md-2">
                {/* <ul class="nav flex-column order_box_left ">
                    <li class="nav-item">
                      <a class="nav-link" href="#">
                        <div class="d-flex ">
                            <div class=""><span class="active">01.</span> </div>
                            <div class="ps-3 ">Buyer Details</div>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link disabled" href="#">
                            <div class="d-flex ">
                                <div class=""><span class="">02</span> </div>
                                <div class="ps-3 ">Pickup Details</div>
                            </div>
                        </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link disabled" href="#">
                        <div class="d-flex ">
                            <div class=""><span class="">03</span> </div>
                            <div class="ps-3 ">Order Details</div>
                        </div>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link disabled" href="#">
                        <div class="d-flex ">
                            <div class=""><span class="">04</span> </div>
                            <div class="ps-3 ">Package Details</div>
                        </div>
                      </a>
                    </li>
                  </ul> */}
                  <Order_left_panel value={3} />
              </div>
              <div class="col-12 col-md">
                <h4 class="pb-3">Order Details</h4>
                <div class="card border-0 order_box">
                  <div class="card-body">
                    <section class="pb-3">
                        <div class="row">
                            <div class="col-12 col-md-4 mb-3">
                                <label for="" class="form-label">Order ID: <small class="text-muted">(Leave Blank for Auto Generate)</small></label>
                                {parsed.order_id==""?
                                <input type="text" class="form-control" id="" placeholder="Order ID" value ={state.order_number} name="order_number" onChange={(e)=>handleChange(e)}  />
                                :  <input type="text" class="form-control" id="" placeholder="Order ID" value ={state.order_number} name="order_number" onChange={(e)=>handleChange(e)}  disabled/>}
                            </div>
                            <div class="col-12 col-md-4 mb-3">
                                <label for="" class="form-label">Order Date:</label>
                                <input type="date" class="form-control" id="" placeholder="Enter Full Name" value={state.order_date} name="order_date" onChange={(e)=>handleChange(e)} />
                            </div>
                        </div>
                    </section>
                    <hr />
                    <section class="pb-3">
                        <h6 class="mb-4">Product Details</h6>
                        {shipstate.map((sub,index)=>(
                        <div class="row">
                            <div class="col-12 col-md-4 mb-3">
                                <label for="" class="form-label">Product {index+1} Name:</label>
                                <input type="text" class="form-control" id="" placeholder="Enter your product name" name="shipment_content" onChange={(e) => handleChange3(e,index)} value={sub.shipment_content} />
                                {(sub.error.shipment_content)?
                               <>
                               <i class="fa fa-exclamation-triangle" style={{color:"rgb(167, 37, 20)"}} aria-hidden="true"></i><small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>Product Name is required</small></>:""}  
                            </div>
                          

                            <div class="col-12 col-md-2 mb-3">
                              <label for="" class="form-label">Unit Price:</label>
                                <div class="input-group">
                                    <span class="input-group-text">&#8377;</span>
                                    <input type="number" class="form-control" placeholder="Enter Price"  name="total_value" onChange={(e) => handleChange3(e,index)} value={sub.total_value}/>
                                </div>
                                {(sub.error.total_value)?
                               <>
                               <i class="fa fa-exclamation-triangle" style={{color:"rgb(167, 37, 20)"}} aria-hidden="true"></i><small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>Unit Price is required</small></>:""}
                            </div>
                           

                            <div class="col-12 col-md-2 mb-3">
                                <label for="" class="form-label">Quantity:</label>
                                <input type="number" class="form-control" id="" placeholder="Enter quantity" name="quantity" onChange={(e) => handleChange3(e,index)} value={sub.quantity}/>
                                {(sub.error.quantity)?
                               <>
                               <i class="fa fa-exclamation-triangle" style={{color:"rgb(167, 37, 20)"}} aria-hidden="true"></i><small style={{color:"rgb(167, 37, 20)" ,fontSize: "0.75rem",
                               lineHeight: "1.66667",
                               fontWeight: "400",
                               letterSpacing: "0.05em",marginLeft:"4px"}}>Quantity is required</small></>:""}
                            </div>
                          

                          
                            <div class="col-12 col-md-1 mb-3">
                              <div class=" add_btns">
                              {/* <a href="#" class="btn btn-primary btn-xs"><i class="material-icons-outlined">minus</i></a> */}
                              {(sub.buttonType == "add") ?
                            //    <a href="#" class="btn btn-primary btn-xs"><i class="material-icons-outlined">add</i></a>
                                <a  class="btn btn-primary btn-xs"><i class="material-icons-outlined" onClick={() => addRows(1)} style={{ cursor: "pointer" }}>add</i></a>:
                                <a  class="btn btn-primary btn-xs"><i class="material-icons-outlined" onClick={() => addRows(2, index)} style={{ cursor: "pointer"}}>remove</i></a>
                                
                                  }
                              </div>
                            </div>
                        </div> 
                        ))}
                    </section>
                    <div class="row">
                    <div class="col-12 col-md-4">
                      <h6 class="">Shipment Type</h6>
                      <div class="row mb-3">
                          <div class="col-12 col-md-12 mb-3">
                            <div>
                              <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio"  onChange={(e)=>handleChange(e)} name="document" id="inlxineRadio1" value="Document"  checked={documenttype.document==true && parceltype.parcel==false}/>
                                <label class="form-check-label" for="inlineRadio1">Document</label>
                              </div>
                              <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="parcel" onChange={(e)=>handleChange(e)} id="inlixneRadio2" value="Parcel" checked={parceltype.parcel==true && documenttype.document==false }/>
                                <label class="form-check-label" for="inlineRadio2">Parcel </label>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
                    <hr/>
                    <section class="pb-3">
                        <h6 class="mb-1">Payment Details</h6>
                        <small class="">Select mode of payment that your buyer has chosen for the order</small>
                        <div class="row mt-4">
                            <div class="col-12 col-md-2 mb-3">
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" name="prepaid" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)} checked={paymentmode.mode==1} />
                                  <label class="form-check-label" for="inlineRadio1">Prepaid <a href="#" data-bs-toggle="popover"  data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Payment already received from the Buyer" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></label>
                                </div>
                            </div>
                            <div class="col-12 col-md mb-3">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input"  type="radio" name="cod" id="inlineRadio1" value="option1" onChange={(e) => payment_mode(e)}  checked={paymentmode.mode==2} />
                                <label class="form-check-label" for="inlineRadio1">COD (Cash On Delivery) <a href="#" data-bs-toggle="popover"  data-bs-placement="top" data-bs-trigger="hover" data-bs-content="COD payment will be credited to your account" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></label>
                              </div>
                            </div>
                        </div>
                        {paymentmode.mode==2?
                        <div class="row">
                          <div class="col-12 col-md-5 mb-3">
                            <input type="text" class="form-control" id="" placeholder="Enter COD amount" name="cod_amount" onChange={(e)=>codvalueChange(e)} value={codvalue.cod_amount} />
                          </div>
                      </div>
                      :""}
                    </section>
                    <hr />
                    <div class="card border-0 bg-light">
                      <div class="card-body">
                        {/* <div class="d-flex justify-content-between pb-2">
                            <div class="">
                              Sub-total for Product
                            </div>
                            <div class="">Rs. 0</div>
                        </div> */}
                        {/* <div class="d-flex justify-content-between pb-4">
                          <div class="">
                            Other Charges
                          </div>
                          <div class="">Rs. 0</div>
                        </div> */}
                        <div class="d-flex justify-content-between">
                          <div class="">
                            <h5>Total Order Value</h5>
                          </div>
                          <div class=""><h5>Rs.{totalValue} </h5></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="py-4 text-end">
                  <a onClick={()=> navigate({pathname:`/customer/create_order_2`,
                                search: `sender_name=${parsed.sender_name}&sender_address=${parsed.sender_address}&sender_country=${parsed.sender_country}&sender_country_code=${parsed.sender_country_code}&sender_postal_code=${parsed.sender_postal_code}&sender_state_name=${parsed.sender_state_name}&sender_city=${parsed.sender_city}&sender_address_id=${parsed.sender_address_id}&sender_city_id=${parsed.sender_city_id}&sender_mobile=${parsed.sender_mobile}&sender_email=${parsed.sender_email}&receiver_name=${parsed.receiver_name}&receiver_email=${parsed.receiver_email}&receiver_mobile=${parsed.receiver_mobile}&receiver_address=${parsed.receiver_address}&receiver_country=${parsed.receiver_country}&receiver_country_code=${parsed.receiver_country_code}&receiver_postal_code=${parsed.receiver_postal_code}&receiver_city=${parsed.receiver_city}&receiver_state_name=${parsed.receiver_state_name}&return_name=${parsed.return_name}&return_email=${parsed.return_email}&return_mobile=${parsed.return_mobile}&return_address=${parsed.return_address}&return_country=${parsed.return_country}&return_country_code=${parsed.return_country_code}&return_postal_code=${parsed.return_postal_code}&return_city=${parsed.return_city}&return_state_name=${parsed.return_state_name}&mode=${parsed.mode}&items=${parsed.items}&shipment_type=${state.parcel_type}&insurance=${insurancestate.insurance}&order_id=${state.order_number}&order_date=${state.order_date}&cod_amount=${codvalue.cod_amount}&payment_mode=${paymentmode.mode==1?"prepaid":"cod"}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_state_id=${parsed.receiver_state_id}&receiver_city_id=${parsed.receiver_city_id}&carrier_type=${parsed.carrier_type}&order_type=${parsed.order_type}`
                              })   } class="btn btn-secondary me-2">Back</a>
                  <a onClick={()=>next_step()} class="btn btn-primary">Next</a>
              </div>
              </div>
            </div>      
          </div>
        </section>
        
   </div>

    {/* <?php include 'footer.php';?> */}
    {/* </section> */}
    <Footer/>
    </div>
  )
}

export default Create_order_3
